'use client'

import { Text } from '@mantine/core'

import SearchableSelect from '@/components/basic/SearchableSelect'
import { I18nLink, useI18nRouter } from '@/i18n/navigation'
import { CoinCategory } from '@/services/category'

import { defaultAllCoinCategoriesOption } from '../../configs'

interface CategorySelectProps {
  categories: CoinCategory[]
}

export default function CategorySelect({ categories }: CategorySelectProps) {
  const selectCategories = [defaultAllCoinCategoriesOption, ...categories]

  const router = useI18nRouter()
  function handleCategoryChange(category: CoinCategory) {
    // Navigate to categories page or specific category detail page
    if (category.slug !== 'all') {
      router.push(`/categories/${category.slug}`)
    }
  }

  return (
    <>
      <div
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          overflow: 'hidden',
          clip: 'rect(0,0,0,0)',
        }}
        aria-hidden="true"
      >
        {categories.map(category => (
          <I18nLink key={category.slug} href={`/price/categories/${category.slug}`}>
            {category.name}
          </I18nLink>
        ))}
      </div>
      <SearchableSelect
        options={selectCategories}
        value={selectCategories[0]}
        onChange={handleCategoryChange}
        renderOptionContent={(item, _isSelected) =>
          item.slug !== 'all' ? (
            <I18nLink href={`/categories/${item.slug}`}>
              <Text variant="body" lineClamp={2}>
                {item.name}
              </Text>
            </I18nLink>
          ) : (
            <Text variant="body">{item.name}</Text>
          )
        }
        getOptionKey={item => item.slug}
        getOptionLabel={item => item.name}
        searchFilter={(item, search) =>
          [item.slug, item.name].some(value => value.toLowerCase().includes(search))
        }
        searchPlaceholder="Search"
      />
    </>
  )
}
